import * as React from 'react';

import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as DocumentsStore from '@store/documents';
import { ManageDocuments } from '@components/documents/ManageDocuments';

export default connect(
    (state: ApplicationState) => ({
        ...state.identity,
        ...state.user,
        ...DocumentsStore.plainActions,
	moduleManager: state.modules.moduleManager,
        work: state.user.work,
    }),
    {}
)(ManageDocuments as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
